const DropdownItem = ({ active, onClick, label }) => {

  return (
    <div 
      className={`p-2 rounded-lg cursor-pointer hover:bg-slate-100 ${active ? 'bg-blue-50 text-blue-600 font-bold' : ''}`}
      onClick={onClick}
    >
      {label}
    </div>
  )
}

export default DropdownItem